/**
 * pano-hero.js
 * Interactive power selector for the hero configurator section.
 * Searches from .pano-hero-section (Shopify section wrapper) to find
 * both the hero area and the configurator card below it.
 */
(function () {
  'use strict';

  function sectionOf(el) {
    return el.closest('.pano-hero-section') || document;
  }

  // Build the CTA destination from the selected power + battery toggle.
  // - Without battery: power-specific collection (solar + autoconsommation).
  // - With battery: autoconsommation collection filtered to that power.
  function updateCta(section) {
    var grid = section.querySelector('[data-pano-power-grid]');
    var cta = section.querySelector('[data-pano-cta]');
    if (!grid || !cta) return;

    var selected = grid.querySelector('[data-pano-kw][aria-pressed="true"]')
      || grid.querySelector('[data-pano-kw]');
    if (!selected) return;

    var kw = selected.dataset.panoKw;
    var battery = section.querySelector('[data-pano-battery]');
    var withBattery = !!(battery && battery.checked);

    var ctaKw = section.querySelector('[data-pano-cta-kw]');
    if (ctaKw) {
      ctaKw.textContent = kw + ' kWc' + (withBattery ? ' avec batterie' : '');
    }

    cta.href = withBattery
      ? '/collections/kits-autoconsommation?filter.p.m.specs.puissance_totale=' + kw + '+kWc'
      : '/collections/kits-' + kw + '-kwc';
  }

  function pulse(cta) {
    if (!cta) return;
    cta.classList.remove('pano-hero__cta-pulse');
    void cta.offsetWidth;
    cta.classList.add('pano-hero__cta-pulse');
  }

  // Power card selection (event delegation survives Shopify section re-render)
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-pano-kw]');
    if (!card) return;

    var grid = card.closest('[data-pano-power-grid]');
    if (!grid) return;

    e.preventDefault();

    grid.querySelectorAll('[data-pano-kw]').forEach(function (c) {
      c.setAttribute('aria-pressed', 'false');
    });
    card.setAttribute('aria-pressed', 'true');

    var section = sectionOf(card);
    updateCta(section);
    pulse(section.querySelector('[data-pano-cta]'));
  });

  // Battery toggle
  document.addEventListener('change', function (e) {
    var toggle = e.target.closest('[data-pano-battery]');
    if (!toggle) return;
    var section = sectionOf(toggle);
    updateCta(section);
    pulse(section.querySelector('[data-pano-cta]'));
  });

  // Sync CTA with the pre-selected power card on load
  function init() {
    document.querySelectorAll('[data-pano-power-grid]').forEach(function (grid) {
      updateCta(sectionOf(grid));
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Keyboard navigation across power cards
  document.addEventListener('keydown', function (e) {
    if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
    var focused = document.activeElement;
    if (!focused || !focused.hasAttribute('data-pano-kw')) return;

    var grid = focused.closest('[data-pano-power-grid]');
    if (!grid) return;

    var cards = Array.from(grid.querySelectorAll('[data-pano-kw]'));
    var idx = cards.indexOf(focused);
    if (idx === -1) return;

    var next = e.key === 'ArrowRight'
      ? (idx + 1) % cards.length
      : (idx - 1 + cards.length) % cards.length;

    cards[next].focus();
    cards[next].click();
    e.preventDefault();
  });
})();
